import { FormControl, Grid, TextField } from "@mui/material";

import FilterLabel from "./utils/FilterLabel";
import FilterController from "./utils/FilterController";
import { Label } from "@mui/icons-material";

const InstitutionFilters = ({ errors, values, handleChange, setValues , Labels }) => {
  return (
    <>
      <Grid item>
        <FormControl margin="dense" fullWidth>
          <FilterLabel sx={{ fontSize: 16 }}>Institution</FilterLabel>
        </FormControl>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <FilterController label={Labels.sender} error={errors.institutionSender}>
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.institutionSender}
                value={values.institutionSender}
                onChange={handleChange}
                name="institutionSender"
              />
            </FilterController>
          </Grid>
          <Grid item xs={2}>
            <FilterController
              label={Labels.receiver}
              error={errors.institutionReceiver}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.institutionReceiver}
                value={values.institutionReceiver}
                onChange={handleChange}
                name="institutionReceiver"
              />
            </FilterController>
          </Grid>
          <Grid item xs={2}>
            <FilterController
              label={Labels.customer56}
              error={errors.f56AIntermediaryBank}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f56AIntermediaryBank}
                value={values.f56AIntermediaryBank}
                onChange={handleChange}
                name="f56AIntermediaryBank"
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item  md={4} xs={2}>
            <FilterController
              label={Labels.customer53}
              error={errors.f53ASenderCorrespondent}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f53ASenderCorrespondent}
                value={values.f53ASenderCorrespondent}
                onChange={handleChange}
                name="f53ASenderCorrespondent"
              />
            </FilterController>
          </Grid>
          <Grid item  md={4} xs={2}>
            <FilterController
              label={Labels.customer54}
              error={errors.f54AReceiverCorrespondent}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f54AReceiverCorrespondent}
                value={values.f54AReceiverCorrespondent}
                onChange={handleChange}
                name="f54AReceiverCorrespondent"
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item  md={4} xs={2}>
            <FilterController
              label={Labels.customer52}
              error={errors.f52AOrderingInstitution}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f52AOrderingInstitution}
                value={values.f52AOrderingInstitution}
                onChange={handleChange}
                name="f52AOrderingInstitution"
              />
            </FilterController>
          </Grid>
          <Grid item md={4} xs={2}>
            <FilterController
              label={Labels.customer57}
              error={errors.f57AAccountInstitution}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f57AAccountInstitution}
                value={values.f57AAccountInstitution}
                onChange={handleChange}
                name="f57AAccountInstitution"
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default InstitutionFilters;
